export class PsCompanyManagement {
    static MY_CONTRACTORS = 'contractors';
    static MY_OUTSOURCES = 'outsources';
}



// WEBPACK FOOTER //
// ./src/app/shared/model/PsCompanyManagement.js